import { defaultCurrencyFormat } from 'src/common/defaultCurrencyFormat';

interface RefundAmountCellProps {
  value: number;
}
export function RefundAmountCell({ value }: RefundAmountCellProps) {
  return <div>{defaultCurrencyFormat(value)}</div>;
}
